import IEvent from '@/models/dto/IEvent';
import EventService from '@/api/services/event.service';
import IAlert from '@/models/modelView/IAlert';
import store from '@/store/index';
import EventStrategyFactory from '@/strategies/event.strategy/event.strategy.factory';
import { events } from '@/utils/mockup-api-events';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({ dynamic: true, store, name: 'alerts' })
class Alerts extends VuexModule {
    //STORE
    events: IEvent[] = events

    soundActive = true;

    //GETTERS
    get mapAlerts(): IAlert[] {
        return this.events.map(event => {
            return EventStrategyFactory.map(event).mapEvent()
        })
    }

    //MUTATIONS
    @Mutation
    setSoundActive(newVal: boolean): void {
        this.soundActive = newVal;
    }

    @Mutation
    setEvents(events: any): void {
        this.events = events;
    }

    @Mutation
    setNewEvents(events: any[]): void {
        this.events = events.concat(this.events);
    }

    //ACTIONS
    @Action({ commit: 'setEvents' })
    async getEvents() {
        const { data } = await EventService.getEvents()
        return data
    }

    @Action({ commit: 'setNewEvents' })
    async getNewEvents() {
        const { data } = await EventService.getNewEvents(this.events[0]?.id || 0)
        // eslint-disable-next-line
        const audio = new Audio(require('@/assets/audio/alert.mp3'))
        const p_alert = document.getElementById('p-alerts')!
        if (data.length > 0) {
            if (this.soundActive) audio.play()
            p_alert.style.animation = "1.1s ease new-alert-primary infinite"
            setTimeout(() => p_alert.style.animation = "none", 6000)
        }
        return data
    }
}
export default getModule(Alerts);